<div class="flex justify-center">
  <div class="page-container">
    <div style="text-align: center">
      <h3 class="paragraph">Herausgeber dieser Webseiten ist das</h3>
      <h3 class="paragraph">Bundesamt für Sicherheit in der Informationstechnik (BSI)</h3>
      <h3 class="paragraph">Referat DI 21 - Cyber-Sicherheit für die Digitalisierung der Energiewirtschaft</h3>
    </div>

    <div class="column-container">
      <div class="column">
        <div class="mt-2 flex align-center">
          <div [matTooltip]="addressTooltip" class="circle flex align-center justify-center"
               matTooltipPosition="left">
            <img alt="home" src="assets/home.svg">
          </div>
          <div>
            <h3 class="paragraph">Godesberger Allee 185-189</h3>
            <h3 class="paragraph">53175 Bonn</h3>
          </div>
        </div>

        <div class="mt-2 flex align-center">
          <div [matTooltip]="telephoneTooltip" class="circle flex align-center justify-center"
               matTooltipPosition="left">
            <img alt="phone" src="assets/phone.svg">
          </div>
          <h3 class="paragraph">+49 228 99 9582-0</h3>
        </div>

        <div class="mt-2 flex align-center">
          <div [matTooltip]="faxTooltip" class="circle flex align-center justify-center"
               matTooltipPosition="left">
            <img alt="fax" src="assets/fax.svg">
          </div>
          <h3 class="paragraph">+49 228 99 9582-5400</h3>
        </div>
      </div>

      <div class="column">
        <div class="mt-2 flex align-center">
          <div [matTooltip]="emailTooltip" class="circle flex align-center justify-center"
               matTooltipPosition="left">
            <img alt="alternate_email" src="assets/alternate_email.svg">
          </div>
          <a class="paragraph" href="mailto:bsi@bsi.bund.de"> bsi@bsi.bund.de</a>
        </div>

        <div class="mt-2 flex align-center">
          <div [matTooltip]="webTooltip" class="circle flex align-center justify-center"
               matTooltipPosition="left">
            <img alt="web" src="assets/web.svg">
          </div>
          <a class="paragraph" href="https://bsi.bund.de" rel="noopener" target="_blank">www.bsi.bund.de</a>
        </div>

        <div class="mt-2 flex align-center">
          <div [matTooltip]="taxIdTooltip" class="circle flex align-center justify-center"
               matTooltipPosition="left">
            <img alt="123" src="assets/account_balance.svg">
          </div>
          <h3 class="paragraph">DE 811 329 482</h3>
        </div>
      </div>
    </div>
  </div>

</div>
